import { Button, Col, Divider, Form, Input, Select, Space } from "antd";
import  get from "lodash/get";
import  map from "lodash/map";
import { PlusOutlined } from "@ant-design/icons";

const SuperVisorInput =({onAddSuperVisor, setNewStaff, staffList, newStaff})=>{
    return(
         <Col md={4} xs={24}>
            <Form.Item
              label="Supervisor"
              name="supervisor"
              rules={[
                {
                  required: true,
                  message: "Please select Supervisor...!",
                },
              ]}
            >
              <Select
                size="small"
                showSearch
                placeholder="Select Supervisor"
                options={map(get(staffList, "superVisorsList"), (supervisor) => ({
                  label: supervisor,
                  value: supervisor,
                }))}
                dropdownRender={(menu) => (
                  <>
                    {menu}
                    <Divider style={{ margin: "8px 0" }} />
                    <Space size={[24, 24]} className="justify-center pl-2" wrap>
                      <Input
                        placeholder="Add new supervisor"
                        value={get(newStaff, "newSupervisor")}
                        className="w-full"
                        size="small"
                        onChange={(e) => setNewStaff({...newStaff,newSupervisor:e.target.value})}
                      />

                      <Button
                        type="link"
                        icon={<PlusOutlined />}
                        disabled={get(newStaff, "newSupervisor") ? false : true}
                        onClick={() => {
                          onAddSuperVisor();
                        }}
                        size="small"
                      >
                        Add Supervisor
                      </Button>
                    </Space>
                  </>
                )}
              />
            </Form.Item>
          </Col>
    )
}
export default SuperVisorInput